import { formatISO, parseISO } from 'date-fns';


type GroupedByDate<TData> = {
    [dateString: string]: TData[]
};

/**
 * Given an array of items, returns an object which groups the items based on the date stored in the
 * object's dateKey property
 *
 * @param items   - The items to group by date
 * @param dateKey - The key in the item that contains the date to compare
 */
export function groupByDate<TData extends {}>(items: TData[] | undefined, dateKey: keyof TData): GroupedByDate<TData> {
    const results: GroupedByDate<TData> = {};

    items?.forEach((item) => {
        const dateStr = item[dateKey];

        if (typeof dateStr !== 'string') {
            throw new Error('An item passed to groupByDate is not a string');
        }

        const formattedDate = formatISO(parseISO(dateStr), { representation: 'date' });
        const resultArray: TData[] = results[formattedDate] || [];

        resultArray.push(item);
        results[formattedDate] = resultArray;
    });

    Object.values(results).forEach((resultArray) => {
        resultArray.sort((resultA, resultB) => (
            parseISO(resultB[dateKey] as unknown as string).getTime()
            - parseISO(resultA[dateKey] as unknown as string).getTime()
        ));
    });

    return results;
}
